import React from 'react';
import styles from '../../css/primereact/resources/themes/tailwind-light/theme.module.css';

const Home = () => {
  return <h1 className={styles["p-component"]} style={{textDecorationLine: 'Underline', textAlign: 'center'}}>Home</h1>;
};

export default Home;
